import { BaseEntity } from "yt-ng-framework";

export class EOtpremnicaPrevoz extends BaseEntity{
    constructor(){
        super();
    }   

    EOtpremnicaID: number = null;
    PrevoznikID: number = null;
    PrevoznikVoziloID: number = null;
    BrojVoznje: number=null;
    PibPrevoznika: string=null;
    NazivPrevoznika: string=null;
    UlicaPrevoznika: string=null;
    DodatnoUlicaPrevoznika: string=null;
    GradPrevoznika: string=null;
    PostanskiBrojPrevoznika: string=null;
    PodentitetPrevoznika: string=null;
    BrojUUliciPrevoznika: string=null;
    MaticniBrojPrevoznika: string=null;
    EmailPrevoznika: string=null;
    RegistarskiBrojPrevoznika: string=null;
    PocetnaLokacijaPrevoznika: string=null;
    PretovarnaTackaPrevoznika: string=null;
    EmailVozaca: string=null;
    ImeVozaca: string=null;
    PrezimeVozaca: string=null;
    TelefonVozaca: string=null;
    TipDokumentaVozaca: string=null;
    ImeZaLicno: string=null;
    PrezimeZaLicno: string=null;
    BrojLicneKarte: string=null;
    VozacBrojVozackeDozvole: string = null;
    PrevoznikPocetnaLokacijaID: number = null;
    PrevoznikPretovarnaTackaID: number = null;

     Deserialize(input:any){  
        super.Deserialize(input);

        this.ID=input.ID;
        this.EOtpremnicaID=input.EOtpremnicaID;
        this.PrevoznikID = input.PrevoznikID;
        this.PrevoznikVoziloID=input.PrevoznikVoziloID;
        this.BrojVoznje=input.BrojVoznje;
        this.PibPrevoznika=input.PibPrevoznika;
        this.NazivPrevoznika=input.NazivPrevoznika;
        this.UlicaPrevoznika=input.UlicaPrevoznika;
        this.DodatnoUlicaPrevoznika=input.DodatnoUlicaPrevoznika;
        this.GradPrevoznika=input.GradPrevoznika;
        this.PostanskiBrojPrevoznika=input.PostanskiBrojPrevoznika;
        this.PodentitetPrevoznika=input.PodentitetPrevoznika;
        this.BrojUUliciPrevoznika=input.BrojUUliciPrevoznika;
        this.MaticniBrojPrevoznika=input.MaticniBrojPrevoznika;
        this.EmailPrevoznika=input.EmailPrevoznika;
        this.RegistarskiBrojPrevoznika=input.RegistarskiBrojPrevoznika;
        this.PocetnaLokacijaPrevoznika=input.PocetnaLokacijaPrevoznika;
        this.PretovarnaTackaPrevoznika=input.PretovarnaTackaPrevoznika;
        this.EmailVozaca=input.EmailVozaca;
        this.ImeVozaca=input.ImeVozaca;
        this.PrezimeVozaca=input.PrezimeVozaca;
        this.TelefonVozaca=input.TelefonVozaca;
        this.TipDokumentaVozaca=input.TipDokumentaVozaca;
        this.VozacBrojVozackeDozvole=input.VozacBrojVozackeDozvole;
        // this.ImeZaLicno=input.ImeZaLicno;
        // this.PrezimeZaLicno=input.PrezimeZaLicno;
        // this.BrojLicneKarte=input 
        this.PrevoznikPocetnaLokacijaID=input.PrevoznikPocetnaLokacijaID;
        this.PrevoznikPretovarnaTackaID=input.PrevoznikPretovarnaTackaID;       

        return this;
    }
        Serialize(input:EOtpremnicaPrevoz){
        return input;
    }
}